export default __webpack_public_path__ + "static/media/tursib-card.d8e39b8d.png";